import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  standalone: true,
  selector: 'email-tellent-logo',
  styleUrls: ['./email-tellent-logo.component.less'],
  template: `
    <a href="https://www.tellent.com/" target="_blank">
      <img class="logo" [src]="'assets/tellent.png'" [width]="152" [height]="32" alt="Tellent" />
    </a>
  `,
  imports: [EmailImageAssetDirective, EmailMailgunIfDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailTellentLogoComponent {}
